import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    history, paySubscription
} from './../../services/membership';
import swal from 'sweetalert';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { intToMoney } from '../../helpers/currency';
import { useNavigate } from 'react-router';
import MembershipInfo from './MembershipInfo';
import Loading from '../Loading';
import { renderOrderType, renderStatus } from '../../helpers/membershipOrder';

const MembershipOrderList = () => {
    const navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        async function getList(){
            setLoading(true);

            const res = await history(auth.token);
            if(res.error === null){
                setOrders(res.data);
            }else{
                swal('Error', res.error, 'error');
            }

            setLoading(false);
        }

        getList();
    }, [auth]);

    const invokePayment = async () => {
        //show confirmation
        const confirm = await swal({
            title: 'Konfirmasi',
            text: 'Apakah anda yakin ingin membayar tagihan ini?',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        });

        if(confirm){
            setSubmitLoading(true);

            const res = await paySubscription(auth.token);
            if(res.error === null){
                //go to payment
                navigate('/membership/order/'+res.data.id);
            }else{
                swal('Error', res.error, 'error');
            }

            setSubmitLoading(false);
        }
    }

    return loading ? <Loading /> : (
        <div>
            <h3><b>Riwayat Pembayaran Iuran</b></h3>
            <div className='box mt-3 p-3'>
                <MembershipInfo />
            </div>
            <button disabled={submitLoading} onClick={() => invokePayment()} className='btn btn-default mt-3'>
                { submitLoading ? <Loading /> : 'Bayar Iuran' }
            </button>
            {
                orders !== null ? (
                    orders.map((order, index) => (
                        <div onClick={
                            () => navigate('/membership/order/'+order.id)
                        } key={index} className="box p-4 mb-3 mt-3" style={{
                            cursor: 'pointer'
                        }}>
                            <Row>
                                <Col md={8} lg={8}>
                                    <div>
                                        <span style={{
                                            fontSize: '14px',
                                            color: '#696969',
                                            fontWeight: 'bold'
                                        }}>
                                            {order.membership_name}
                                        </span>
                                        <span style={{
                                            fontSize: '12px',
                                            color: '#868686',
                                            marginLeft: '10px'
                                        }}>
                                            { moment(order.created_at).format('HH:mm, DD MMM YYYY') }
                                        </span>
                                        <span style={{
                                            fontSize: '12px',
                                            color: '#868686',
                                            marginLeft: '10px'
                                        }}>
                                            { renderStatus(order.status) }
                                        </span>
                                        <span style={{
                                            fontSize: '12px',
                                            color: '#868686',
                                            marginLeft: '10px'
                                        }}>
                                            #{ order.jurnal_transaction_no }
                                        </span>
                                    </div>
                                    <Row>
                                        <Col sm={8}>
                                            <div>
                                                { renderOrderType(order.type) }
                                            </div>
                                            <div style={{
                                                fontSize: '12px',
                                                color: '#868686'
                                            }}>
                                                { intToMoney(order.total_cost) }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={4} lg={4} className="text-end ">
                                    <div style={{
                                        fontSize: '14px',
                                        fontWeight: 'light',
                                        color: '#828282'
                                    }}>Total Harga:</div>
                                    <div style={{
                                        fontSize: '14px',
                                        fontWeight: 'bold'
                                    }}>
                                        { intToMoney(order.total_cost) }
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    ))
                ) : null
            }
        </div>
    );
}

export default MembershipOrderList;